var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuestTalks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "#dddddd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6C10 4.89543 10.8954 4 12 4C13.1046 4 14 4.89543 14 6H13C12.4477 6 12 6.44772 12 7C12 7.55228 12.4477 8 13 8H14V10H13C12.4477 10 12 10.4477 12 11C12 11.5523 12.4477 12 13 12H14V13C14 14.1046 13.1046 15 12 15C10.8954 15 10 14.1046 10 13V6ZM12 2C9.79086 2 8 3.79086 8 6V13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13V11V7V6C16 3.79086 14.2091 2 12 2ZM7 11C7 10.4477 6.55228 10 6 10C5.44772 10 5 10.4477 5 11V13C5 16.5265 7.60771 19.4439 11 19.9291V21H8C7.44772 21 7 21.4477 7 22C7 22.5523 7.44772 23 8 23H12H16C16.5523 23 17 22.5523 17 22C17 21.4477 16.5523 21 16 21H13V19.9291C16.3923 19.4439 19 16.5265 19 13V11C19 10.4477 18.5523 10 18 10C17.4477 10 17 10.4477 17 11V13C17 15.7614 14.7614 18 12 18C9.23858 18 7 15.7614 7 13V11Z",
    fill: "#6344ae"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestTalks);
export default __webpack_public_path__ + "static/media/guest-talks.454ced868a79f1b59571502de51ada38.svg";
export { ForwardRef as ReactComponent };